<template>
  <v-snackbar
    v-model="show"
    :timeout="12000"
    :multi-line="true"
    top
  >
    {{ errorMessage }}
    <template #action="{ attrs }">
      <v-btn
        color="pink"
        text
        v-bind="attrs"
        @click="show = false"
      >
        CLOSE
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'ErrorSnackbar',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: "Oops, something went wrong. We're looking into it."
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    errorMessage() {
      return this.error ? this.error : "Oops, something went wrong. We're looking into it."
    }
  }
}
</script>